<template>
  <div>
    <my_menu2 page_name="员工技能证书" back_type="close" back_icon="md-close"></my_menu2>
    <div style="height: 50px"></div>
    <div class="content">
      <div
        class="cert_inner"
        v-for="(item, i) in cert_list"
        :key="i"
        title="点击查看证书照片"
        @click="click_view(item)"
      >
        <div>
          <span class="cert_name">{{ item.cert_name }}</span>
        </div>
        <div>
          <span class="cert_name2">证书编号：</span>
          <span class="cert_value">{{
            item.cert_id_number ? item.cert_id_number : "-"
          }}</span>
        </div>
        <div>
          <span class="cert_name2">证书开始时间：</span>
          <span class="cert_value">{{ item.start_time_fmt }}</span>
        </div>
        <div>
          <span class="cert_name2">证书结束时间：</span>
          <span v-if="item.is_long_term == 0" class="cert_value">{{
            item.end_time_fmt
          }}</span>
          <span v-else class="cert_value">长期</span>
        </div>
        <div>
          <span class="cert_name2">证书照片：</span>
          <span class="cert_value">{{ item.img_list.length }}张</span>
        </div>
        <div>
          <span class="cert_name2">提交时间：</span>
          <span class="cert_value">{{ item.create_time_fmt }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import my_menu2 from "@/component/menu/menu2.vue";
import { http, open_new_page } from "@/utils/http.js";

export default {
  components: { my_menu2 },

  data() {
    return {
      resume_id: "",
      cert_list: [],
    };
  },
  mounted() {
    console.log(this.$route.query.resume_id);
    // var query = this.$router.query;
    this.resume_id = this.$route.query.resume_id;
    this.get_cert_list_data();
  },
  methods: {
    click_view(item) {
      var url_list = [];
      for (var i = 0; i < item.img_list.length; i++) {
        url_list.push(item.img_list[i]["url"]);
      }
      this.$ImagePreview.show({
        previewList: url_list,
      });
    },

    get_cert_list_data() {
      console.log("加载");
      var that = this;
      var _dict = {
        resume_id: this.resume_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/roster_manage/certificate/resume_certificate_list",
        _dict,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.cert_list = res.data.cert_list;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },
  },
};
</script>

<style scoped>
.cert_value {
  font-size: 13px;
}

.cert_name {
  font-weight: 600;
}

.cert_name2 {
  font-size: 13px;
}

.content {
  padding: 0 10px 10px 10px;
  display: flex;
  flex-wrap: wrap;
}

.cert_inner {
  border: 1px solid #ececec;
  border-radius: 5px;
  box-shadow: 0 0 3px #ededed;
  padding: 10px 15px;
  width: 230px;
  cursor: pointer;
}

.cert_inner:hover {
  background: #0466dd;
  color: #fff;
}
</style>
